import PortalIdParser from 'PortalIdParser';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
const HYPHEN_SEPARATOR = '-';
const COLON_SEPARATOR = ':';
const PIPELINE_SETTINGS_REGEX = /(deal|ticket)-(default|[0-9]+|[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[89AB][0-9A-F]{3}-[0-9A-F]{12})-(.+)/i;
export const isNumeric = value => /^-?\d+$/.test(value); // Path value parsers

export const pipelineSettingsPathValueParser = (uuid = '') => {
  const matches = PIPELINE_SETTINGS_REGEX.exec(uuid) || []; // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const [, appName, pipelineId, stageId] = matches;

  if (pipelineId) {
    return {
      pipelineId
    };
  }

  return null;
};
export const ecommPathValueParser = (uuid = '') => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [appName, pipelineName, portalId, ...storeToken] = uuid.split(HYPHEN_SEPARATOR);

  if (appName === 'ecomm' && storeToken && storeToken.length) {
    return {
      storeToken: storeToken.join(HYPHEN_SEPARATOR)
    };
  }

  return null;
};
export const forecastingPathValueParser = (uuid = '') => {
  const [, pipelineId] = uuid.split(COLON_SEPARATOR);

  if (pipelineId) {
    return {
      pipelineId
    };
  }

  return null;
};
export const customerFeedbackSurveyPathValueParser = (uuid = '') => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [appNamePart1, appNamePart2, surveyType, surveyLiteral, surveyId, stage] = uuid.split(HYPHEN_SEPARATOR);
  /* eslint-enable @typescript-eslint/no-unused-vars */

  if (appNamePart1 === 'feedback' && appNamePart2 === 'embedded' && isNumeric(surveyId)) {
    let surveyRoute = '';

    switch (surveyType) {
      case 'ces':
        surveyRoute = 'support';
        break;

      case 'csat':
        surveyRoute = 'satisfaction';
        break;

      case 'nps':
        surveyRoute = 'loyalty';
        break;

      case 'custom':
        surveyRoute = 'custom';
        break;

      default:
    }

    if (surveyRoute) {
      return {
        surveyId,
        surveyRoute
      };
    }
  }

  return null;
}; // uuid format: form-field-followup-<pageId>-<moduleId>

export const formFieldFollowupValueParser = (uuid = '') => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [,,, pageId, moduleId] = uuid.split(HYPHEN_SEPARATOR);

  if (pageId) {
    return {
      pageId
    };
  }

  return null;
}; // uuid format: <portalId>:<formGuid>:<RandomString>

export const formsAppValueParser = (uuid = '') => {
  const [, formGuid] = uuid.split(COLON_SEPARATOR);

  if (formGuid) {
    return {
      formGuid
    };
  }

  return null;
}; // uuid format: <portalId>-<emailId>-<emailEventTypes>

export const marketingEmailAutomatedValueParser = (uuid = '') => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [portalId, emailId, emailEventTypes] = uuid.split(HYPHEN_SEPARATOR);

  if (emailId) {
    return {
      emailId
    };
  }

  return null;
}; // uuid format: sequence-<sequenceId>-<creationTimestampMillis>

export const sequencesContextualAutomationValueParser = (uuid = '') => {
  const [, sequenceId] = uuid.split(HYPHEN_SEPARATOR);

  if (sequenceId) {
    return {
      sequenceId
    };
  }

  return null;
}; // uuid format: cms-form-module-field-<formId>-<pageId>-<timestamp>

export const cmsFormModuleFieldValueParser = (uuid = '') => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [,,,, formId, pageId] = uuid.split(HYPHEN_SEPARATOR);

  if (pageId) {
    return {
      pageId
    };
  }

  return null;
}; // uuid format: cms:form:module:field:followup:email:<pageId>:<formId>

export const cmsFormModuleFieldFollowupEmailParser = (uuid = '') => {
  const [,,,,,, pageId] = uuid.split(COLON_SEPARATOR);

  if (pageId) {
    return {
      pageId
    };
  }

  return null;
};
export const adsFlowValueParser = (uuid = '') => {
  const [prefix, adNetwork, adAccountId, campaignId, adGroup, adId] = uuid.split(HYPHEN_SEPARATOR); // Check the prefix to make sure we don't build urls for legacy ads flows

  const ADS_SIMPLE_WORKFLOW_UUID_PREFIX = 'adss';
  /**
   * Don't return data for ads lead based workflows since we can't construct the proper URL
   * Context: https://git.hubteam.com/HubSpot/AutomationTeam/issues/5063
   */

  const ADS_LEAD_ID = 'lead';

  if (prefix === ADS_SIMPLE_WORKFLOW_UUID_PREFIX && adNetwork && adNetwork !== ADS_LEAD_ID && adAccountId && campaignId && adGroup && adId) {
    return {
      adNetwork,
      adAccountId,
      campaignId,
      adGroup,
      adId
    };
  }

  return null;
}; // uuid format: skill-based-routing-<channelInstanceId>

export const skillBasedRoutingPathValueParser = (uuid = '') => {
  const [,,, channelInstanceId] = uuid.split(HYPHEN_SEPARATOR);

  if (channelInstanceId) {
    return {
      channelInstanceId
    };
  }

  return null;
}; // URL builders

const dealPipelineSettingsURL = () => `/sales-products-settings/${PortalIdParser.get()}/deals`;

const dealPipelineSettingsDirectURL = ({
  pipelineId
}) => `/pipelines-settings/${PortalIdParser.get()}/object/0-3/${pipelineId}/automation`;

const ticketPipelineSettingsURL = () => `/sales-products-settings/${PortalIdParser.get()}/tickets`;

const ticketPipelineSettingsDirectURL = ({
  pipelineId
}) => `/pipelines-settings/${PortalIdParser.get()}/object/0-5/${pipelineId}/automation`;

const ticketEmailStatusSettingURL = () => `/sales-products-settings/${PortalIdParser.get()}/tickets`;

const ticketEmailStatusSettingDirectURL = ({
  pipelineId
}) => `/pipelines-settings/${PortalIdParser.get()}/object/0-5/${pipelineId}/automation`;

const ecommURL = () => `/integrations-settings/${PortalIdParser.get()}/ecommerce`;

const ecommDirectURL = ({
  storeToken
}) => `/integrations-settings/${PortalIdParser.get()}/ecommerce?storeToken=${storeToken}`;

const quotesApplicationURL = () => `/settings/${PortalIdParser.get()}/sales/quotes`;

const customerFeedbackSurveyURL = () => `/feedback/${PortalIdParser.get()}/dashboard/manage/surveys/all`;

const customerFeedbackSurveyDirectURL = ({
  surveyId,
  surveyRoute
}) => `/feedback-editor/${PortalIdParser.get()}/${surveyRoute}/${surveyId}/automation`;

const forecastingURL = () => `/settings/${PortalIdParser.get()}/sales/forecasting`;

const forecastingDirectURL = ({
  pipelineId
}) => `/settings/${PortalIdParser.get()}/sales/forecasting/${pipelineId}`;

const formFieldFollowupUrl = () => `/website/${PortalIdParser.get()}/pages/landing`;

const formFieldFollowupDirectUrl = ({
  pageId
}) => `/content/${PortalIdParser.get()}/edit/${pageId}/content`;

const formsAppURL = () => `/forms/${PortalIdParser.get()}`;

const formsAppDirectURL = ({
  formGuid
}) => `/forms/${PortalIdParser.get()}/editor/${formGuid}/edit/automation`;

const leadFlowsAppDirectURL = ({
  formGuid
}) => `/lead-flows/${PortalIdParser.get()}/edit/${formGuid}/automation`;

const marketingEmailAutomatedUrl = () => `/email/${PortalIdParser.get()}`;

const marketingEmailAutomatedDirectUrl = ({
  emailId
}) => `/email/${PortalIdParser.get()}/edit/${emailId}/automation`;

const sequencesContextualAutomationUrl = () => `/sequences/${PortalIdParser.get()}`;

const sequencesContextualAutomationDirectUrl = ({
  sequenceId
}) => `/sequences/${PortalIdParser.get()}/sequence/${sequenceId}/edit`;

const cmsFormModuleFieldUrl = () => `/website/${PortalIdParser.get()}/pages`;

const cmsFormModuleFieldDirectUrl = ({
  pageId
}) => `/pages/${PortalIdParser.get()}/editor/${pageId}/content`;

const cmsFormModuleFieldFollowupEmailUrl = () => `/website/${PortalIdParser.get()}/pages`;

const cmsFormModuleFieldFollowupEmailDirectUrl = ({
  pageId
}) => `/pages/${PortalIdParser.get()}/editor/${pageId}/content`;
/*
const leadFlowAutomationURL = formId => {
  const portalId = PortalIdParser.get();
  return `/lead-flows/${portalId}/edit/${formId}/follow-up`;
};
*/


const adsFlowURL = () => `/ads/${PortalIdParser.get()}`;

const adsFlowDirectURL = ({
  adNetwork,
  adAccountId,
  campaignId,
  adGroup,
  adId
}) => `/ads/${PortalIdParser.get()}/${adNetwork}/${adAccountId}/campaigns/${campaignId}/adgroups/${adGroup}/ad/${adId}/edit/automation`;

const APPROXIMATE_URL_BUILDERS = {
  [SourceApps.ADS_FLOW]: adsFlowURL,
  [SourceApps.DEAL_PIPELINE_SETTINGS]: dealPipelineSettingsURL,
  [SourceApps.TICKET_PIPELINE_SETTINGS]: ticketPipelineSettingsURL,
  [SourceApps.TICKET_EMAIL_STATUS_SETTING]: ticketEmailStatusSettingURL,
  [SourceApps.EMBEDDED_QUOTES]: quotesApplicationURL,
  [SourceApps.FEEDBACK_FOLLOW_UP]: customerFeedbackSurveyURL,
  [SourceApps.FORECASTING]: forecastingURL,
  [SourceApps.FORMS_APP]: formsAppURL,
  [SourceApps.LEAD_FLOWS_APP]: formsAppURL,
  [SourceApps.ECOMM]: ecommURL,
  [SourceApps.FORM_FIELD_FOLLOWUP]: formFieldFollowupUrl,
  [SourceApps.MARKETING_EMAIL_AUTOMATED]: marketingEmailAutomatedUrl,
  [SourceApps.SEQUENCES_CONTEXTUAL_AUTOMATION]: sequencesContextualAutomationUrl,
  [SourceApps.CMS_FORM_MODULE_FIELD]: cmsFormModuleFieldUrl,
  [SourceApps.CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL]: cmsFormModuleFieldFollowupEmailUrl
};
const DIRECT_URL_BUILDERS = {
  [SourceApps.ADS_FLOW]: adsFlowDirectURL,
  [SourceApps.DEAL_PIPELINE_SETTINGS]: dealPipelineSettingsDirectURL,
  [SourceApps.TICKET_PIPELINE_SETTINGS]: ticketPipelineSettingsDirectURL,
  [SourceApps.TICKET_EMAIL_STATUS_SETTING]: ticketEmailStatusSettingDirectURL,
  [SourceApps.FEEDBACK_FOLLOW_UP]: customerFeedbackSurveyDirectURL,
  [SourceApps.FORECASTING]: forecastingDirectURL,
  [SourceApps.FORMS_APP]: formsAppDirectURL,
  [SourceApps.LEAD_FLOWS_APP]: leadFlowsAppDirectURL,
  [SourceApps.ECOMM]: ecommDirectURL,
  [SourceApps.FORM_FIELD_FOLLOWUP]: formFieldFollowupDirectUrl,
  [SourceApps.MARKETING_EMAIL_AUTOMATED]: marketingEmailAutomatedDirectUrl,
  [SourceApps.SEQUENCES_CONTEXTUAL_AUTOMATION]: sequencesContextualAutomationDirectUrl,
  [SourceApps.CMS_FORM_MODULE_FIELD]: cmsFormModuleFieldDirectUrl,
  [SourceApps.CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL]: cmsFormModuleFieldFollowupEmailDirectUrl
};
const PATH_VALUE_PARSERS = {
  [SourceApps.ADS_FLOW]: adsFlowValueParser,
  [SourceApps.DEAL_PIPELINE_SETTINGS]: pipelineSettingsPathValueParser,
  [SourceApps.TICKET_PIPELINE_SETTINGS]: pipelineSettingsPathValueParser,
  [SourceApps.TICKET_EMAIL_STATUS_SETTING]: pipelineSettingsPathValueParser,
  [SourceApps.FEEDBACK_FOLLOW_UP]: customerFeedbackSurveyPathValueParser,
  [SourceApps.FORECASTING]: forecastingPathValueParser,
  [SourceApps.FORMS_APP]: formsAppValueParser,
  [SourceApps.LEAD_FLOWS_APP]: formsAppValueParser,
  [SourceApps.ECOMM]: ecommPathValueParser,
  [SourceApps.FORM_FIELD_FOLLOWUP]: formFieldFollowupValueParser,
  [SourceApps.MARKETING_EMAIL_AUTOMATED]: marketingEmailAutomatedValueParser,
  [SourceApps.SEQUENCES_CONTEXTUAL_AUTOMATION]: sequencesContextualAutomationValueParser,
  [SourceApps.CMS_FORM_MODULE_FIELD]: cmsFormModuleFieldValueParser,
  [SourceApps.CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL]: cmsFormModuleFieldFollowupEmailParser,
  [SourceApps.SKILL_BASED_ROUTING]: skillBasedRoutingPathValueParser
};
export const getEmbedSourceAppDirectURL = (sourceApp, uuid) => {
  if (uuid) {
    const buildDirectURL = DIRECT_URL_BUILDERS[sourceApp];
    const parser = PATH_VALUE_PARSERS[sourceApp];

    if (buildDirectURL && parser) {
      const valueMap = parser(uuid);

      if (valueMap) {
        return buildDirectURL(valueMap);
      }
    }
  }

  return null;
};

const getEmbedSourceAppApproxURL = sourceApp => {
  const buildApproxURL = APPROXIMATE_URL_BUILDERS[sourceApp];

  if (buildApproxURL) {
    return buildApproxURL();
  }

  return null;
};

export const getEmbedSourceAppBestURL = (sourceApp, uuid) => {
  const directURL = getEmbedSourceAppDirectURL(sourceApp, uuid);

  if (directURL) {
    return directURL;
  }

  const approxURL = getEmbedSourceAppApproxURL(sourceApp);

  if (approxURL) {
    return approxURL;
  }

  if (sourceApp !== SourceApps.WORKFLOWS_CLASSIC) {
    console.warn(`Unrecognized source app: ${sourceApp}. Please add to sourceAppLinkUtils.getEmbedSourceAppBestURL`);
  }

  return null;
};